var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var Update = function Update(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M9.374 5.478A7.031 7.031 0 0 1 16 17.783V15a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h5a1 1 0 1 0 0-2h-2.293a9.03 9.03 0 0 0-9.08-15.378 1 1 0 0 0 .747 1.856ZM6.63 7.16a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01ZM4.06 10a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V11a1 1 0 0 1 1-1ZM5.63 15.1a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01ZM7.16 17.37a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0v-.01a1 1 0 0 1 1-1ZM12 19.94a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0v-.01Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default Update;